<template>
  <div>
    <chatList />
  </div>
</template>

<script>
import ChatList from "../components/ChatList.vue";

export default {
  components: {
    ChatList,
  },
};
</script>
